<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <PageTitle title="Bank Account" subtitle="Bank Account Details" />
        <div class="form_text">
          <div class="text bank_account_body_wrapper">
            You have not set your Bank Account Details yet, please provide your
            details to ensure you are paid for your shifts
          </div>
        </div>
        <el-button class="submit_page" type="blue" @click="goContinue('userForm')">
          Continue
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, inject  } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline, downloadOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
  "download-outline": downloadOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";

import { useRouter } from "vue-router";
import { useStore } from "vuex";
import formHooks from "@/hooks/form/form";
import PageTitle from "@/components/PageTitle/PageTitle.vue";
export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    PageTitle
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };

    const userData = $store.getters.GET_USER_DATA;
    const mobileNumberConversion = inject("mobileNumberConversion");
    const formattedNumber = mobileNumberConversion(userData);
    const formsDataArray = {
      userForm: {
        mobileNumber: {
          value: formattedNumber,
        },
      },
    };
    const goContinue = (userForm) => {
    
      return (async () => {
        try {
          if (userData.mobileNumber) {
            await $store.dispatch(
              "VERIFY_MOBILE_BANK_ACCOUNT",
              getFormValues(userForm)
            );
          }
          $router.push({
            name: "verify_mobile",
          });
        } catch (errors) {
          console.log(errors);
        }
      })();
    };

    onMounted(() => { });

    const {
      getFormValues,
      formsData,
    } = formHooks(formsDataArray);

    return {
      formsData,
      goBack,
      goContinue,
      userData,
      formattedNumber,
      mobileNumberConversion
    };
  },
};
</script>